import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Country } from 'mapfre-auditlib';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { BusinessUnit } from 'mapfre-auditlib';

@Injectable({
  providedIn: 'root'
})

export class ProcessService {

  className = 'ProcessService';

  constructor(private http: HttpClient) { }

  getCorporativeMap(businessUnit, version = "latest"): Observable<any> {
    let params = {}
    if (version) {
      params = {
        version
      }
    }
    return this.http.get<any>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}`, { params });
  }

  getLocalMap(businessUnit, country, version = "latest"): Observable<any> {
    let params = {}
    if (version) {
      params = {
        version
      }
    }
    return this.http.get<any>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}/country-process/${country.idCountryPk}`, { params });
  }

  saveMap(businessUnit, country, map) {
    let pathParams = country ? `${businessUnit.idUnitBusinessPk}/${country.idCountryPk}` : `${businessUnit.idUnitBusinessPk}`
    let cleanMap = this.cleanTree(map);
    return this.http.post<any>(`${environment.base_URL}/business-processes`, cleanMap);
  }

  cleanTree(tree) {
    return _.map(tree, (n) => {
      return this.cleanNodeDepth(n);
    })
  }

  cleanNodeDepth(node) {
    delete node.parent;
    delete node.form;
    if (node.children) {
      node.children = _.map(node.children, (c) => {
        return this.cleanNodeDepth(c);
      })
    }
    return node
  }

}

